import AlbumPage from './AlbumPage';

export default AlbumPage;
